export class AnimationConstants {
  public static json_paths = {
    call: "https://prestemos-assets.s3.amazonaws.com/json/call.json",
    clap: "https://prestemos-assets.s3.amazonaws.com/json/clap.json",
    ups: "https://prestemos-assets.s3.amazonaws.com/json/ups.json",
    location_blue: "https://prestemos-assets.s3.amazonaws.com/json/location_blue.json",
    error_screen: "https://prestemos-assets.s3.amazonaws.com/json/error_screen.json",
    connection_lost: "https://prestemos-assets.s3.amazonaws.com/json/connection_lost.json",
    error_message: "https://prestemos-assets.s3.amazonaws.com/json/error-animation.json",
    cinematic_bureau: "https://prestemos-assets.s3.amazonaws.com/json/cinematic_bureau.json",
    logout: "https://prestemos-assets.s3.amazonaws.com/json/logout.json",
    free_trial: "https://prestemos-assets.s3.amazonaws.com/json/free_trial.json",
    car_animation: "https://prestemos-assets.s3.us-east-1.amazonaws.com/json/car.json",
    car_animation_2: "https://prestemos-assets.s3.us-east-1.amazonaws.com/json/car-2.json",
    car_animation_3: "https://prestemos-assets.s3.us-east-1.amazonaws.com/json/car_animation_3.json",
    check_list_loading: "https://prestemos-assets.s3.us-east-1.amazonaws.com/json/checklist.json",
    time_over: "https://prestemos-assets.s3.us-east-1.amazonaws.com/json/time-over.json",
    photo_phone_front_document:
      "https://prestemos-assets.s3.us-east-1.amazonaws.com/json/Free_Photo_Phone_Front_Document_Animation.json",
    photo_phone_back_document:
      "https://prestemos-assets.s3.us-east-1.amazonaws.com/json/Photo_Phone_Back_Document_Animation.json",
    selfie: "https://prestemos-assets.s3.us-east-1.amazonaws.com/json/selfie_animation.json",
    car_crash: "https://prestemos-assets.s3.us-east-1.amazonaws.com/json/car_crash.json",
    bell: "https://prestemos-assets.s3.amazonaws.com/json/bell.json",
    confetti: "https://prestemos-assets.s3.amazonaws.com/json/confetti.json",
    location: "https://prestemos-assets.s3.amazonaws.com/json/location.json",
    rocket: "https://prestemos-assets.s3.amazonaws.com/json/rocket.json",
    sad_guy: "https://prestemos-assets.s3.amazonaws.com/json/sad_guy.json",
    store: "https://prestemos-assets.s3.amazonaws.com/json/store.json",
    camera_red: "https://prestemos-assets.s3.amazonaws.com/json/camera_red.json",
    camera_night_blue: "https://prestemos-assets.s3.amazonaws.com/json/camera_night_blue.json",
    connect_vpn: "https://prestemos-assets.s3.amazonaws.com/json/connect_vpn.json",
    document_verification: "https://prestemos-assets.s3.amazonaws.com/json/document-verification.json",
    no_data_preview: "https://prestemos-assets.s3.amazonaws.com/json/no-data-preview-clean.json",
    no_data_preview_with_add: "https://prestemos-assets.s3.amazonaws.com/json/no-data-preview.json",
    files_not_found: "https://prestemos-assets.s3.amazonaws.com/json/files-not-found.json",
  };
}
